import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from 'vue';
import { getGroupNames, venturesMap } from '~/functions/accounts';
import { formatAsGermanDate } from '~/functions/helpers';
import { useGetAccountQuery, useListEsgPortfolioVentureLinksQuery, useUpdateVentureCommentMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'esgList',
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var normalizeQueryValue = function normalizeQueryValue(value) {
      if (Array.isArray(value)) return value[0];
      if (value === null || value === undefined || value === '') return undefined;
      return String(value);
    };
    var buildSyncedQuery = function buildSyncedQuery(query, newOptions) {
      var nextQuery = {};
      for (var _i = 0, _Object$entries = Object.entries(query || {}); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        var normalized = normalizeQueryValue(value);
        if (normalized !== undefined) nextQuery[key] = normalized;
      }
      nextQuery.page = String(newOptions.page);
      nextQuery.itemsPerPage = String(newOptions.itemsPerPage);
      nextQuery.sortBy = String(newOptions.sortBy);
      nextQuery.sortDesc = String(newOptions.sortDesc);
      return nextQuery;
    };
    var isSameQuery = function isSameQuery(a, b) {
      var keys = Array.from(new Set([].concat(_toConsumableArray(Object.keys(a || {})), _toConsumableArray(Object.keys(b || {})))));
      return keys.every(function (key) {
        return normalizeQueryValue(a === null || a === void 0 ? void 0 : a[key]) === normalizeQueryValue(b === null || b === void 0 ? void 0 : b[key]);
      });
    };
    var normalizeEsgSortKey = function normalizeEsgSortKey(sortBy) {
      switch (sortBy) {
        case 'total':
          return 'esg.total';
        case 'envperformance':
          return 'esg.environmental';
        case 'socperformance':
          return 'esg.social';
        case 'govperformance':
          return 'esg.governance';
        case 'updatedAt':
          return 'esg.updatedAt';
        case 'submittedAt':
          return 'esg.submittedAt';
        default:
          return sortBy || 'esg.total';
      }
    };
    var getDefaultSortDescForKey = function getDefaultSortDescForKey(sortBy) {
      // Company names should default to ascending (A -> Z).
      if (sortBy === 'venture.name') return false;
      return true;
    };
    var resolveSortDesc = function resolveSortDesc(sortBy, rawSortDesc) {
      if (rawSortDesc === 'true') return true;
      if (rawSortDesc === 'false') return false;
      return getDefaultSortDescForKey(sortBy);
    };
    var _useGetAccountQuery = useGetAccountQuery(undefined, {
        fetchPolicy: 'cache-and-network'
      }),
      result = _useGetAccountQuery.result,
      refetchAccount = _useGetAccountQuery.refetch;
    var account = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
    });
    var venturesMapping = computed(function () {
      return venturesMap(account.value);
    });
    var options = ref({
      page: route.query.page ? parseInt(route.query.page, 10) || 1 : 1,
      itemsPerPage: route.query.itemsPerPage ? parseInt(route.query.itemsPerPage, 10) || 10 : 10,
      sortBy: normalizeEsgSortKey(route.query.sortBy),
      sortDesc: resolveSortDesc(normalizeEsgSortKey(route.query.sortBy), route.query.sortDesc)
    });
    watch(function () {
      return route.query;
    }, function (newQuery) {
      var normalizedSortBy = normalizeEsgSortKey(newQuery.sortBy);
      var sortByChanged = normalizedSortBy !== options.value.sortBy;
      if (sortByChanged) {
        options.value.sortBy = normalizedSortBy;
        // When switching to Company sorting from another key,
        // always start with ascending.
        if (normalizedSortBy === 'venture.name') {
          options.value.sortDesc = false;
          return;
        }
      }
      var nextSortDesc = resolveSortDesc(normalizedSortBy, newQuery.sortDesc);
      if (nextSortDesc !== options.value.sortDesc) {
        options.value.sortDesc = nextSortDesc;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(function () {
      return {
        page: options.value.page,
        itemsPerPage: options.value.itemsPerPage,
        sortBy: options.value.sortBy,
        sortDesc: options.value.sortDesc
      };
    }, function (newOptions) {
      var nextQuery = buildSyncedQuery(route.query, newOptions);
      if (isSameQuery(route.query, nextQuery)) return;
      router.replace({
        query: nextQuery
      }).catch(function () {
        // Ignore cancelled/duplicated navigations during rapid route-query sync.
      });
    }, {
      deep: true
    });
    var variables = computed(function () {
      return {
        filters: {
          text: route.query.search || '',
          group: route.query.group || '',
          hasEsgResult: undefined,
          minEnvironmentalScore: undefined,
          periodStartFrom: route.query.periodStart || undefined,
          periodEndTo: route.query.periodEnd || undefined
        },
        // reset page to 1 when search changes (still shown as 2 in UI and url and returns to 2 if the search is cleared)
        offset: route.query.search !== undefined ? 0 : options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage,
        sortBy: options.value.sortBy,
        sortDesc: options.value.sortDesc
      };
    });
    var _useListEsgPortfolioV = useListEsgPortfolioVentureLinksQuery(variables, {
        fetchPolicy: 'cache-and-network'
      }),
      ventureLinksResult = _useListEsgPortfolioV.result,
      loading = _useListEsgPortfolioV.loading,
      refetch = _useListEsgPortfolioV.refetch;
    var itemCount = computed(function () {
      var _ventureLinksResult$v;
      return ((_ventureLinksResult$v = ventureLinksResult.value) === null || _ventureLinksResult$v === void 0 ? void 0 : _ventureLinksResult$v.countPortfolioVentureLinks) || 0;
    });
    var ventureLinks = computed(function () {
      var _ventureLinksResult$v2;
      return ((_ventureLinksResult$v2 = ventureLinksResult.value) === null || _ventureLinksResult$v2 === void 0 ? void 0 : _ventureLinksResult$v2.listPortfolioVentureLinks) || [];
    });
    var items = computed(function () {
      return ventureLinks.value.map(function (link) {
        var _link$comment;
        var summary = link.esgSummary || {};
        return _objectSpread(_objectSpread({}, link), {}, {
          isCompleted: summary.isCompleted,
          total: summary.total,
          totalDiffToPrevious: summary.totalDiffToPrevious,
          environmental: summary.environmental,
          environmentalDiffToPrevious: summary.environmentalDiffToPrevious,
          social: summary.social,
          socialDiffToPrevious: summary.socialDiffToPrevious,
          governance: summary.governance,
          governanceDiffToPrevious: summary.governanceDiffToPrevious,
          disclosure: summary.disclosure,
          period: summary.period,
          submittedAt: summary.submittedAt,
          groupNames: getGroupNames(link.ventureId, venturesMapping.value),
          comment: (_link$comment = link.comment) !== null && _link$comment !== void 0 ? _link$comment : null
        });
      });
    });
    var _useUpdateVentureComm = useUpdateVentureCommentMutation(),
      updateVentureComment = _useUpdateVentureComm.mutate;
    var selected = ref([]);
    var headers = computed(function () {
      return [{
        text: '',
        value: 'logo',
        width: '48px',
        sort: false
      }, {
        sort: true,
        align: 'start',
        class: 'th',
        value: 'venture.name'
      }, {
        value: 'groupNames',
        sort: false
      }, {
        value: 'total',
        sort: true
      }, {
        value: 'envperformance',
        sort: true
      }, {
        value: 'socperformance',
        sort: true
      }, {
        value: 'govperformance',
        sort: true
      }, {
        value: 'disclosure',
        sort: false
      }, {
        value: 'referencePeriod',
        sort: false
      }, {
        value: 'submittedAt',
        sort: true
      }, {
        value: 'comment',
        sort: false
      }].map(function (v) {
        return _objectSpread({
          align: 'center',
          class: 'th',
          text: v.value === 'logo' ? '' : $i18n.t("esg.portfolioListView.headers.".concat(v.value)),
          sortable: false
        }, v || {});
      });
    });
    var sortKeys = computed(function () {
      var base = headers.value.filter(function (v) {
        return v.sort;
      }).map(function (_ref) {
        var value = _ref.value;
        return {
          text: $i18n.t("esg.portfolioListView.sortBy", {
            column: $i18n.t("esg.portfolioListView.headers.".concat(value))
          }),
          // Map header values to backend sort keys
          value: function () {
            switch (value) {
              case 'total':
                return 'esg.total';
              case 'envperformance':
                return 'esg.environmental';
              case 'socperformance':
                return 'esg.social';
              case 'govperformance':
                return 'esg.governance';
              case 'venture.name':
                return 'venture.name';
              case 'updatedAt':
                return 'esg.updatedAt';
              case 'submittedAt':
                return 'esg.submittedAt';
              default:
                return value;
            }
          }()
        };
      });
      var extra = [{
        text: $i18n.t('esg.portfolioListView.headers.periodStartSort'),
        value: 'esg.periodStart'
      }, {
        text: $i18n.t('esg.portfolioListView.headers.periodEndSort'),
        value: 'esg.periodEnd'
      }];
      return [].concat(_toConsumableArray(base), extra);
    });
    return {
      __sfc: true,
      router: router,
      route: route,
      $i18n: $i18n,
      normalizeQueryValue: normalizeQueryValue,
      buildSyncedQuery: buildSyncedQuery,
      isSameQuery: isSameQuery,
      normalizeEsgSortKey: normalizeEsgSortKey,
      getDefaultSortDescForKey: getDefaultSortDescForKey,
      resolveSortDesc: resolveSortDesc,
      result: result,
      refetchAccount: refetchAccount,
      account: account,
      venturesMapping: venturesMapping,
      options: options,
      variables: variables,
      ventureLinksResult: ventureLinksResult,
      loading: loading,
      refetch: refetch,
      itemCount: itemCount,
      ventureLinks: ventureLinks,
      items: items,
      updateVentureComment: updateVentureComment,
      selected: selected,
      headers: headers,
      sortKeys: sortKeys,
      formatAsGermanDate: formatAsGermanDate
    };
  }
});